import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { injectIntl } from 'react-intl';
import EventsPageComponent from '@fuww/library/src/Layouts/EventsPage';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import Events from '../components/Events';
import EventPage from '../lib/eventPage';
import LinkAndAnchor from '../components/LinkAndAnchor';
import withApollo from '../lib/apollo';
import getCurrentDate from '../components/Events/getCurrentDate';

const headerImageUrls = {
  mobile: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=34,quality=10,width=42/https://media.fashionunited.com/media/tradeshow-header.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=288,quality=70,width=360/https://media.fashionunited.com/media/tradeshow-header.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=576,quality=70,width=720/https://media.fashionunited.com/media/tradeshow-header.jpg',
  ],
  desktop: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=8,quality=10,width=42/https://media.fashionunited.com/media/tradeshow-header.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=277,quality=70,width=1350/https://media.fashionunited.com/media/tradeshow-header.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=526,quality=70,width=2560/https://media.fashionunited.com/media/tradeshow-header.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=1052,quality=70,width=5120/https://media.fashionunited.com/media/tradeshow-header.jpg',
  ],
};
class EventsPage extends EventPage {
  static async getInitialProps({ req, res, ...rest }) {
    const properties = await EventPage.getInitialProps({ req, res, ...rest });

    return { ...properties, now: getCurrentDate().toString() };
  }

  render() {
    const {
      intl,
      now,
    } = this.props;

    const breadcrumbs = [
      <HomeLink />,
      <LinkAndAnchor
        route="events"
        passHref
      >
        {intl.formatMessage(messages.events)}
      </LinkAndAnchor>,
    ];

    return (
      <EventsPageComponent
        breadcrumbs={breadcrumbs}
        title={intl.formatMessage(messages.eventsTitle)}
        description={intl.formatMessage(messages.eventsIntro)}
      >
        <Head
          title={intl.formatMessage(messages.eventsTitle)}
          description={intl
            .formatMessage(messages.eventsMetaDescription)}
        />
        <Events now={now} />
      </EventsPageComponent>
    );
  }
}

EventsPage.propTypes = {
  router: PropTypes.shape({}),
  intl: PropTypes.shape({ formatMessage: PropTypes.func }).isRequired,
};

EventsPage.defaultProps = {
  router: {},
};

export const EventsWithoutApollo = withRouter(injectIntl(EventsPage));

EventsWithoutApollo.getLayout = (page) => (
  <Layout
    header={(
      <Hero
        imageUrls={headerImageUrls}
        alt="FashionUnited Events"
      />
  )}
  >
    {page}
  </Layout>
);

export default withApollo(EventsWithoutApollo);
